import { useTranslation } from 'react-i18next'

type Props = {
  page: number
  pageSize: number
  total: number
  onChange: (page: number) => void
}

export default function AdminPagination({ page, pageSize, total, onChange }: Props) {
  const { t } = useTranslation()
  const pages = Math.max(1, Math.ceil(total / pageSize))
  if (total <= pageSize) return null

  return (
    <div className="vc-admin-pagination">
      <button
        type="button"
        className="vc-admin-btn vc-admin-btn--ghost"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        {t('admin.prevPage')}
      </button>
      <span className="vc-admin-muted">
        {t('admin.pageOf', { page, pages, total })}
      </span>
      <button
        type="button"
        className="vc-admin-btn vc-admin-btn--ghost"
        disabled={page >= pages}
        onClick={() => onChange(page + 1)}
      >
        {t('admin.nextPage')}
      </button>
    </div>
  )
}
